
    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    import { SelfScheduleDefault, SelfScheduleDefaultShift } from '@/models';
    import ErrorNotification from "../shared/ErrorNotification.vue";
    import ConfirmMsgPopUp from "@/views/shared/ConfirmMsgPopUp.vue";
    import { namespace } from "vuex-class";
    import moment from "moment";
    import { ModelListSelect } from 'vue-search-select'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';


    const schedule = namespace("schedule");
    const profile = namespace("profile");
    @Component({
        components: {
            ErrorNotification,
            ModelListSelect,
            Loading,
            ConfirmMsgPopUp
        },
    })
    export default class SelfSchedulingDefaultModal extends Vue {
        @schedule.State
        public selfScheduleShiftMembers!: any;

        @schedule.State
        public selfScheduleShiftDetails: any;
        @profile.State
        public profileData!: any;
        @schedule.State
        public selfScheduleFacilities: any;
        @schedule.State
        public selfScheduleDepartments: any;
        @profile.State
        isImpersonating!: boolean;
        @schedule.State
        selfScheduleDefaultShifts: any;
        @schedule.State
        selfScheduleDefaultFacilities: any;
        @schedule.State
        selfScheduleDefaultDepartments: any;
        @schedule.State
        selfScheduleDefaultSkills: any;
        
        shiftMembers: any = [];
        isLoaded: boolean = false;
        isProductive: boolean = false;
        isSelfScheduled: boolean = false;
        deptShifts: any = [];
        skillName!: string;
        buttonCaption: string = "Add to Schedule";
        buttonName: string = "btnAddToSchedule";
        tenantId!: string;
        staffId!: number;
        deptId!: number;
        skillId!: number;
        err: string = '';
        shiftStartTime!: Date;
        shiftEndTime!: Date;
        actualStartTime!: Date;
        actualEndTime!: Date;
        actualShiftStartTime: string = "6:30am";
        actualShiftEndTime: string = "6:30pm";
        deptShiftId: number = 0;
        deptShiftDesc: string = '';
        deptShiftCode!: string;
        productiveType: string = '';
        isModalVisible: boolean = false;
        errorMsg: string = '';
        errorType: string = 'error';
        showErrorMsg: boolean = false;
        classFlag: string = '';
        isSelfScheduleAllowed: boolean = false;
        allowSelfScheduleToCommitment: boolean = false;
        guranteedHrs: number = 0;
        weeksInSchedule: number = 4;
        displayWSC: boolean = true;
        reqCountWSC: number = 0;
        facilities: any = [];
        facilityDepts: any = [];
        selectedFacilityId: number = 0;
        selectedDeptId: number = 0;
        skills: any = [];
        selectedSkillId: number = 0;
        selectedDeptShiftId: string = '';
        selectedDeptAndShift: any = {
            tenantId: '',
            facilityId: 0,
            coid: '',
            facilityName: '',
            departmentId: 0,
            departmentName: '',
            departmentCode: '',
            departmentShiftId: 0,
            shiftCode: '',
            shiftDescription: '',
            startTime: '',
            endTime: '',
            shiftMembers: []
        };
        facilityCoid: number = 0;
        departmentCode: number = 0;
        facilityName: string = '';
        departmentName: string = '';
        isLoading: boolean = false;
        loaderColor: string = "#0085ca";
        isConfirmModalVisible: boolean = false;
        confirmMsgValue: string = '';
        datesList: any = [];
        isSelfScheduleNeedsInPrimaryDept: boolean = true;
        existingDefaultSelfSchedule!: SelfScheduleDefault;

        @Prop() currentShift!: SelfScheduleDefaultShift;
        @Prop() calSelectedDates!: any;

        async mounted() {
            this.buttonCaption = (this.isEmpty(this.currentShift) ? "Add to Schedule" : "Withdraw");
            this.buttonName = (this.isEmpty(this.currentShift) ? "btnAddToSchedule" : "btnWithdraw");
            this.skillName = this.profileData.skills.find(x => x.primary == true).description;
            this.tenantId = this.profileData.tenantId;
            this.staffId = this.profileData.staffId;
            this.deptId = this.profileData.deptId;
            this.skillId = this.profileData.skills.find(x => x.primary == true).id;
            this.isSelfScheduleAllowed = this.profileData.selfSchedule;
            this.allowSelfScheduleToCommitment = this.profileData.selfScheduleToCommitment;
            this.skills = this.profileData.skills;
            this.guranteedHrs = this.profileData.guarenteedHours;
            this.weeksInSchedule = this.profileData.weeksInSchedule;
            this.displayWSC =
                this.profileData.weekendShiftCommitment != 0 ? true : false;
            this.reqCountWSC = this.profileData.weekendShiftCommitment;

            this.existingDefaultSelfSchedule = JSON.parse(localStorage.getItem("DefaultSelfSchedule") || '{}');

            await this.showCalenderSelectedDates();

            if (this.isEmpty(this.currentShift))//
            {
                this.getSelfScheduleNeedsDetails();
            }
            else {
                this.getCurrentShiftDetails();
            }
        }

        async showCalenderSelectedDates() {
            var startSD = moment(this.calSelectedDates.startDate, 'M/D/YYYY');
            var endSD = moment(this.calSelectedDates.endDate, 'M/D/YYYY');
            var diffDays = endSD.diff(startSD, 'days');
            let calCurrentDate: Date = new Date(this.calSelectedDates.startDate);

            for (var i = 0; i < diffDays; i++) {
                let singleDate = {
                    id: i,
                    dayValue: this.getDayValue(calCurrentDate),
                    dateValue: calCurrentDate,
                    isSelected: true
                }
                this.datesList[i] = JSON.parse(JSON.stringify(singleDate));
                calCurrentDate.setDate(calCurrentDate.getDate() + 1);
            }
        }

        isEmpty(obj) {
            return Object.keys(obj).length === 0;
        }

        getDayValue(calDateValue) {
            var returnDayValue: number;
            var monthValue = moment(calDateValue).format("M");
            if (monthValue == "5")// May
            {
                returnDayValue = Number(moment(calDateValue).format("D"));
            }
            else // June
            {
                returnDayValue = Number(moment(calDateValue).format("D")) + 31;
            }
            return returnDayValue;
        }

        getSelfScheduleNeedsDetails() {
            let selectedDateVal = (this.isEmpty(this.currentShift) ? moment(this.datesList[0].dateValue).format('YYYY-MM-DDTHH:mm:ss') : this.currentShift.date);
            var departmentIdVal;
            if (this.isEmpty(this.currentShift)) {
                var lstDeptId = this.deptId.toString();
                if (this.profileData.secondaryDepartments.length > 0) {
                    for (var i = 0; i < this.profileData.secondaryDepartments.length; i++) {
                        if (this.profileData.secondaryDepartments[i].facilityId == this.profileData.facilityId) {
                            lstDeptId = lstDeptId + "," + this.profileData.secondaryDepartments[i].deptId;
                        }
                    }
                }
                departmentIdVal = lstDeptId;
            }
            else {
                departmentIdVal = this.currentShift.departmentId;
            }
            const payload = { date: selectedDateVal, departmentIds: this.profileData.deptId, username: this.profileData.username };

            this.$store
                .dispatch("schedule/getSelfScheduleDefaultShifts", payload)
                .then((data) => {
                    this.isLoaded = true;                    

                    if (this.selfScheduleDefaultShifts != undefined) {
                        this.facilities = this.selfScheduleDefaultFacilities;
                        let selectedFacility = this.facilities.find(f => f.facilityId == this.profileData.facilityId);

                        if (selectedFacility == 'undefined') {
                            selectedFacility = this.selectedFacilityId = this.facilities[0];
                        }

                        this.selectedFacilityId = selectedFacility.facilityId;
                        this.facilityName = selectedFacility.facilityName;
                        this.facilityCoid = selectedFacility.coid;

                        this.facilityDepts = this.selfScheduleDefaultDepartments.filter(x => x.facilityId == selectedFacility.facilityId);
                        let selectedDept = this.facilityDepts.find(d => d.departmentId == this.profileData.deptId);

                        if (selectedDept == 'undefined' || selectedDept == null) {
                            this.isSelfScheduleNeedsInPrimaryDept = false;
                            selectedDept = this.facilityDepts[0]
                        }
                        this.selectedDeptId = selectedDept.departmentId;
                        this.departmentName = selectedDept.departmentCode;
                        this.departmentCode = selectedDept.departmentName;

                        let filteredskills = this.removeDuplicatesFromArrayByProperty(this.selfScheduleDefaultSkills.filter(x => x.departmentId == this.selectedDeptId), 'skillLevelId');                 
                        let primarySkillId = this.profileData.skills.find(x => x.primary == true).id;
                        this.selectedSkillId = filteredskills.find(s => s.skillLevelId == primarySkillId).skillLevelId;
                        
                        this.skills = filteredskills;

                        this.deptShifts = this.removeDuplicatesFromArrayByProperty(this.selfScheduleDefaultShifts.filter(x => x.departmentId == this.selectedDeptId).filter(s => s.skillLevelId = this.selectedSkillId), 'shiftCode');
                        
                        this.deptShifts.forEach((shift: any) => {
                            let startTime, endTime;
                            startTime = this.formatTime(this.addMinutes(shift.startTime, shift.offset));
                            endTime = this.formatTime(this.addMinutes(this.addMinutes(shift.endTime, shift.offset), shift.breakMinutes));

                            if (shift.shiftDescription.trim().toUpperCase() == shift.shiftCode.trim().toUpperCase()) {
                                shift.shiftDescription = shift.shiftDescription + " " + startTime.toUpperCase() + " - " + endTime.toUpperCase();
                            }
                        });

                        this.selectedDeptAndShift = this.deptShifts[0];
                        this.selectedDeptShiftId = +this.deptShifts[0].departmentShiftId + '_' + this.deptShifts[0].departmentId;
                        this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId, this.skills[0].fsSkillLevelId);
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        getCurrentShiftDetails() {
            this.isLoaded = true;
            if (!this.isEmpty(this.currentShift)) {
                this.facilityName = this.currentShift.facilityName;
                this.departmentName = this.currentShift.departmentName;
                this.skillName = this.currentShift.skill;
                this.skillId = this.skills.find(s => s.id == this.currentShift.skillId);
                this.deptShiftId = this.currentShift.departmentShiftId;
                this.deptShiftDesc = this.currentShift.shiftDescription;
                this.shiftStartTime = this.currentShift.startTime;
                this.shiftEndTime = this.currentShift.endTime;
            }
        }

        toggleDateSelection(event) {
            let currentId = event.currentTarget.id;

            for (var i = 0; i < this.datesList.length; i++) {
                if (this.datesList[i].id == currentId) {
                    let currentStatus: boolean = (this.datesList[i].isSelected);
                    this.datesList[i].isSelected = !(this.datesList[i].isSelected);
                    if (currentStatus) {
                        event.currentTarget.classList.remove("neu-background--cerulean-25");
                        event.currentTarget.classList.add("neu-background--white");
                    }
                    else {
                        event.currentTarget.classList.remove("neu-background--white");
                        event.currentTarget.classList.add("neu-background--cerulean-25");
                        if (this.showErrorMsg) {
                            this.showErrorMsg = false;
                            this.errorMsg = "";
                        }
                    }
                }
            }
        }

        onFacilityChange(event) {
            this.selectedFacilityId = event.target.value;
            this.facilityDepts = this.selfScheduleDepartments.filter(x => x.facilityId == event.target.value);
            this.facilityName = this.facilities.find(f => f.facilityId == event.target.value).facilityName;
            this.facilityCoid = this.facilities.find(f => f.facilityId == event.target.value).coid;
            this.selectedDeptId = this.facilityDepts[0].departmentId;
            this.departmentName = this.facilityDepts[0].departmentCode;            
            this.departmentCode = this.facilityDepts[0].departmentName; 
            
            let filteredskills = this.removeDuplicatesFromArrayByProperty(this.selfScheduleDefaultShifts.filter(x => x.departmentId == this.selectedDeptId), 'skillLevelId');                             
            this.selectedSkillId = filteredskills[0].skillLevelId;
            this.skills = filteredskills;

            this.deptShifts = this.removeDuplicatesFromArrayByProperty(this.selfScheduleDefaultShifts.filter(x => x.departmentId == this.selectedDeptId).filter(s => s.skillLevelId = this.selectedSkillId), 'shiftCode');

            this.deptShifts.forEach((shift: any) => {
                let startTime, endTime;
                startTime = this.formatTime(this.addMinutes(shift.startTime, shift.offset));
                endTime = this.formatTime(this.addMinutes(this.addMinutes(shift.endTime, shift.offset), shift.breakMinutes));

                if (shift.shiftDescription.trim().toUpperCase() == shift.shiftCode.trim().toUpperCase()) {
                    shift.shiftDescription = shift.shiftDescription + " " + startTime.toUpperCase() + " - " + endTime.toUpperCase();
                }
            });

            const selecteId = +this.deptShifts[0].departmentShiftId + '_' + this.deptShifts[0].departmentId;
            this.selectedDeptShiftId = selecteId;
            this.selectedDeptAndShift = this.deptShifts[0];
            this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId, this.deptShifts[0].skillLevelId);
        }

        onDepartmentChange(event) {
            this.selectedDeptId = event.target.value;
            this.departmentName = this.selfScheduleDefaultShifts.find(x => x.departmentId == event.target.value).departmentCode;
            this.departmentCode = this.selfScheduleDefaultShifts.find(x => x.departmentId == event.target.value).departmentName;
            
            let filteredskills = this.removeDuplicatesFromArrayByProperty(this.selfScheduleDefaultShifts.filter(x => x.departmentId == this.selectedDeptId), 'skillLevelId');                 
            this.selectedSkillId = filteredskills[0].skillLevelId;
            this.skills = filteredskills;

            this.deptShifts = this.removeDuplicatesFromArrayByProperty(this.selfScheduleDefaultShifts.filter(x => x.departmentId == this.selectedDeptId).filter(s => s.skillLevelId = this.selectedSkillId), 'shiftCode');

            this.deptShifts.forEach((shift: any) => {
                let startTime, endTime;
                startTime = this.formatTime(this.addMinutes(shift.startTime, shift.offset));
                endTime = this.formatTime(this.addMinutes(this.addMinutes(shift.endTime, shift.offset), shift.breakMinutes));

                if (shift.shiftDescription.trim().toUpperCase() == shift.shiftCode.trim().toUpperCase()) {
                    shift.shiftDescription = shift.shiftDescription + " " + startTime.toUpperCase() + " - " + endTime.toUpperCase();
                }
            });

            const selecteId = +this.deptShifts[0].departmentShiftId + '_' + this.deptShifts[0].departmentId;
            this.selectedDeptShiftId = selecteId;
            this.selectedDeptAndShift = this.deptShifts[0];

            this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId, this.deptShifts[0].skillLevelId);
        }

        onSkillChange(event) {
            this.selectedSkillId = event.target.value;
            this.skillName = this.skills.find(x => x.skillLevelId == event.target.value).skill;
        }

        onShiftChanges(event) {
            this.selectedDeptShiftId = event;
            this.selectedDeptAndShift = this.deptShifts.find(x => x.departmentShiftId == event.departmentShiftId && x.departmentId == event.departmentId);
            this.setShiftDetails(event.departmentShiftId, event.departmentId, event.skillLevelId);

            if (this.showErrorMsg) {
                this.showErrorMsg = false;
                this.errorMsg = "";
            }
        }

        setShiftDetails(deptShiftId, deptId, skillLevelId) {
            const selectedDeptShift = this.deptShifts.find(x => x.departmentShiftId == deptShiftId);
            this.shiftMembers = selectedDeptShift.shiftMembers;
            this.shiftStartTime = selectedDeptShift.startTime;
            this.deptShiftCode = selectedDeptShift.shiftCode;
            this.deptShiftDesc = selectedDeptShift.shiftDescription;
            this.productiveType = selectedDeptShift.productiveType;
            this.shiftEndTime = selectedDeptShift.endTime;
            this.actualStartTime = this.addMinutes(selectedDeptShift.startTime, selectedDeptShift.offset);
            this.actualEndTime = this.addMinutes(this.addMinutes(selectedDeptShift.endTime, selectedDeptShift.offset), selectedDeptShift.breakMinutes);
            this.actualShiftStartTime = this.formatTime(this.actualStartTime);
            this.actualShiftEndTime = this.formatTime(this.actualEndTime);            
        }

        removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])

        validateBeforeSave() {            
            let selectedDatesCount: number = 0;
            for (var i = 0; i < this.datesList.length; i++) {
                if (this.datesList[i].isSelected) {
                    selectedDatesCount++;
                }
            }
            if (selectedDatesCount > 0) {
                return true;
            }
            else {
                this.showErrorMsg = true;
                this.errorType = "error";
                this.errorMsg = "Please select atleast one day";
                return false;
            }
        }

        async SaveShiftDetails() {
            if (this.existingDefaultSelfSchedule.defaultShifts != undefined) {
                for (var i = 0; i < this.datesList.length; i++) {
                    if (this.showErrorMsg) {
                        break;
                    }

                    if (this.datesList[i].isSelected == true) //
                    {
                        var dateVal = Number(this.datesList[i].dayValue);
                                                
                        var lstShifts: SelfScheduleDefaultShift[] = this.existingDefaultSelfSchedule.defaultShifts.filter(x => x.dayOfSchedule == dateVal && x.tenantId == this.profileData.tenantId);
                        if (lstShifts != null) {
                            for (var j = 0; j < lstShifts.length; j++) {
                                const selectedDeptShift = this.deptShifts.find(x => x.shiftCode == lstShifts[j].shiftCode);
                                if (selectedDeptShift != undefined && selectedDeptShift != null && (selectedDeptShift.startTime < this.shiftEndTime) && (this.shiftStartTime < selectedDeptShift.endTime)
                                            && selectedDeptShift.tenantId == this.profileData.tenantId) {
                                    this.isLoading = false;
                                    this.showErrorMsg = true;
                                    this.errorMsg = "Shifts may not overlap.\n Please select a shift with a different start or end time.";
                                    return;
                                }
                                else if(selectedDeptShift.facilityId <= 0) {
                                    this.isLoading = false;
                                    this.showErrorMsg = true;
                                    this.errorMsg = "Shift is missing required information.";
                                    return;
                                }
                            }
                        }
                    }
                }
            }
            if (!this.showErrorMsg) {
                this.isLoading = true;
                for (var k = 0; k < this.datesList.length; k++) {
                    if (this.datesList[k].isSelected == true) //
                    {
                        var ShiftDetails = {
                            id: this.getGuidValue(),
                            tenantId: this.tenantId,
                            facilityId: this.selectedFacilityId,
                            coid: this.facilityCoid.toString(),
                            facilityName: this.facilityName,
                            departmentId: this.selectedDeptId,
                            departmentName: this.departmentName,
                            departmentCode: this.departmentCode.toString(),
                            departmentShiftId: this.selectedDeptAndShift.departmentShiftId,
                            dayOfSchedule: Number(this.datesList[k].dayValue),
                            startTime: this.shiftStartTime,
                            endTime: this.shiftEndTime,
                            skillId: this.selectedSkillId,
                            shiftCode: this.deptShiftCode,
                            shiftDescription: this.deptShiftDesc,
                            skill: this.skillName,
                            date: this.datesList[k].dateValue,
                            actualStartTime: this.actualShiftStartTime,
                            actualEndTime: this.actualShiftEndTime,
                            productiveType: this.productiveType
                        };

                        if (this.existingDefaultSelfSchedule.defaultShifts == undefined) {
                            var defaultScheduleDetails = {
                                id: this.profileData.username,
                                username: this.profileData.username,
                                staffId: this.staffId,
                                tenantId: this.tenantId,
                                first: this.profileData.first,
                                last: this.profileData.last,
                                defaultShifts: []
                            }
                            this.existingDefaultSelfSchedule = JSON.parse(JSON.stringify(defaultScheduleDetails));
                        }
                        this.existingDefaultSelfSchedule.defaultShifts.push(JSON.parse(JSON.stringify(ShiftDetails)));
                    }
                }

                localStorage.setItem("DefaultSelfSchedule", JSON.stringify(this.existingDefaultSelfSchedule));
                var retrievedPerson = JSON.parse(localStorage.getItem('DefaultSelfSchedule') || '{}'); //retrieve the object
                this.isLoading = false;
                this.$emit('showSuccessMsgPopUp');
            }
        }

        async FireAction() {
            if (this.isEmpty(this.currentShift) && this.validateBeforeSave() == true) // -- Add toSchedule
            {
                this.SaveShiftDetails();
            }
            else if (!this.isEmpty(this.currentShift)) // -- Withdraw
            {
                this.isLoading = true;
                if (this.existingDefaultSelfSchedule.defaultShifts != undefined) {
                    var selectedShiftIndex = this.existingDefaultSelfSchedule.defaultShifts.findIndex(x => x.id == this.currentShift.id);
                    this.existingDefaultSelfSchedule.defaultShifts.splice(selectedShiftIndex, 1);
                    localStorage.setItem("DefaultSelfSchedule", JSON.stringify(this.existingDefaultSelfSchedule));
                }
                this.isLoading = false;
                this.$emit('showSuccessMsgPopUp');
            }
        }

        getGuidValue() {
            var uuidValue = "", k, randomValue;
            for (k = 0; k < 32; k++) {
                randomValue = Math.random() * 16 | 0;
                if (k == 8 || k == 12 || k == 16 || k == 20) {
                    uuidValue += "-"
                }
                uuidValue += (k == 12 ? 4 : (k == 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
            }
            return uuidValue;
        }

        formatTime(t: Date): string {
            return moment(t).format("h:mm a");
        }

        addMinutes(date, minutes) {
            return moment(date).add(minutes, 'm').toDate();
        }
    }

